<template>
  <div class="order-detail-warp">
    <div id="clean_html">
      <div class="order-detail">
        <div class="order-title">订单详情</div>
        <div class="line-name">{{ order.cruiseName }}</div>
        <div>
          <span class="duration"
            >{{ order.sailDays }}天{{ order.sailDays - 1 }}晚</span
          >
          <span class="ship-name">{{ order.shipName }}</span>
        </div>
        <div class="tips-info">
          {{ order.sailDateBegin }} - {{ order.sailDateEnd }}
        </div>

        <!-- 房间详情 -->

        <div
          class="detail-room-info-warp"
          v-for="(booking, i) in connectBookings"
          :key="'connectBookingPrice_' + i"
        >
          <div class="detail-room-title">
            客房{{ i + 1 }}&nbsp;|&nbsp;房间号:
            <span class="detail-room-number">{{
              booking.stateroomNumber == "GTY"
                ? "随机"
                : booking.stateroomNumber
            }}</span>
          </div>
          <div class="detail-room-name">
            {{ getStateroomName(booking) }}
          </div>

          <!-- 乘客信息 -->
          <div
            class="passenger-info"
            v-for="(guest, j) in booking.guestPrices"
            :key="'guestPrice_' + i + '_' + j"
          >
            <div class="d-passenger-name">{{ getGuestName(j, booking) }}</div>
            <div class="cost-warp">
              <div class="group-cost">
                <span>零售指导价</span>
                <span>￥{{ guest.originalPrice }}</span>
              </div>
              <div class="group-cost">
                <span>港务税费</span>
                <span>￥{{ guest.taxPrice }}</span>
              </div>
            </div>
          </div>

          <div class="totaL-cost">
            <div class="group-cost d-passenger-name">
              <span>零售指导价合计</span>
              <span>￥{{ getOriginalAmount(booking) }}</span>
            </div>
            <div class="discount-info">
              <div class="d-passenger-name">船票优惠详情</div>
              <div>
                <div
                  class="group-cost"
                  v-for="(discount, k) in getDiscountItem(booking)"
                  :key="'discount_' + k"
                >
                  <span>{{ discount.description }}</span>
                  <span>￥{{ discount.amount }}</span>
                </div>
                <div
                  class="group-cost"
                  v-for="(discount, k) in getObcItem(booking)"
                  :key="'obc_' + k"
                >
                  <span>船上消费抵用金</span>
                  <span>${{ discount.amount }}</span>
                </div>
              </div>
            </div>

            <div class="group-cost">
              <span>优惠后船票合计</span>
              <span>￥{{ getDiscountAmount(booking) }}</span>
            </div>

            <div class="group-cost">
              <span>港务税费合计</span>
              <span>￥{{ getTaxAmount(booking) }}</span>
            </div>
            <div class="group-cost" v-if="booking.groupType === 'PCPGIFT' && booking.pcpGiftInfo">
              <span>{{booking.pcpGiftInfo.name}} x{{booking.guestNumber}}</span>
              <span>￥{{ booking.pcpGiftInfo.price }}</span>
            </div>
            <div class="total-cost">
              <div>
                <span class="total-text">合计</span>
                <span class="total-money">￥{{ getTotalPrice(booking) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="detail-room-info-warp"
          v-for="(booking, i) in normalBookings"
          :key="'normalBookingPrice_' + i"
        >
          <div class="detail-room-title">
            客房{{ i + 1 + connectBookings.length }}&nbsp;|&nbsp;房间号:
            <span class="detail-room-number">{{
              booking.stateroomNumber == "GTY"
                ? "随机"
                : booking.stateroomNumber
            }}</span>
          </div>
          <div class="detail-room-name">
            {{ getStateroomName(booking) }}
          </div>

          <!-- 乘客信息 -->
          <div
            class="passenger-info"
            v-for="(guest, j) in booking.guestPrices"
            :key="'guestPrice_' + i + '_' + j"
          >
            <div class="d-passenger-name">{{ getGuestName(j, booking) }}</div>
            <div class="cost-warp">
              <div class="group-cost">
                <span>零售指导价</span>
                <span>￥{{ guest.originalPrice }}</span>
              </div>
              <div class="group-cost">
                <span>港务税费</span>
                <span>￥{{ guest.taxPrice }}</span>
              </div>
            </div>
          </div>

          <div class="totaL-cost">
            <div class="group-cost d-passenger-name">
              <span>零售指导价合计</span>
              <span>￥{{ getOriginalAmount(booking) }}</span>
            </div>
            <div class="discount-info">
              <div class="d-passenger-name">船票优惠详情</div>
              <div>
                <div
                  class="group-cost"
                  v-for="(discount, k) in getDiscountItem(booking)"
                  :key="'discount_' + k"
                >
                  <span>{{ discount.description }}</span>
                  <span>￥{{ discount.amount }}</span>
                </div>
                <div
                  class="group-cost"
                  v-for="(discount, k) in getObcItem(booking)"
                  :key="'obc_' + k"
                >
                  <span>船上消费抵用金</span>
                  <span>${{ discount.amount }}</span>
                </div>
              </div>
            </div>

            <div class="group-cost">
              <span>优惠后船票合计</span>
              <span>￥{{ getDiscountAmount(booking) }}</span>
            </div>

            <div class="group-cost">
              <span>港务税费合计</span>
              <span>￥{{ getTaxAmount(booking) }}</span>
            </div>
            <div class="group-cost" v-if="getBirthdayPrice(booking)">
              <span>生日礼遇</span>
              <span>￥{{ getBirthdayPrice(booking) }}</span>
            </div>
            <div class="group-cost" v-if="booking.groupType === 'PCPGIFT' && booking.pcpGiftInfo">
              <span>{{booking.pcpGiftInfo.name}} x{{booking.guestNumber}}</span>
              <span>￥{{ booking.pcpGiftInfo.price }}</span>
            </div>
            <div class="total-cost">
              <div>
                <span class="total-text">合计</span>
                <span class="total-money">￥{{ getTotalPrice(booking) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="real-cost">
        <div>
          <span class="total-text">应付总计</span>
          <span class="total-money">￥{{ Math.round(totalPrice) }}</span>
        </div>
      </div>
      <div>
      <div class="deposit-info" v-if="isDownPayCruise">
          <!-- <template v-if="isDeluxeStateroom">
            <span>实际订金金额以结算为准</span>
          </template>
          <template v-else>
            <template v-if="order.bookingIndex&&order.bookingIndex.isRow == false">
              <span class="deposit-text">订金价格</span>
              <span class="deposit-money">￥&nbsp;{{ Math.round(totalDeposit) }}元起</span>
            </template>
          </template> -->
          <img class="deposit-currency-symbol" :src="`${imgUrl}/cruiseSearch/icons/deposit-currency-symbol.svg`"/>
          <span class="deposit-text">本订单可选择订金支付¥1000/人起</span>
      </div>
      <div class="real-cost-tips">
          *促销期间舱房紧俏，重选或取消可能导致当前已选房型被其他客人预订！
      </div>
      </div>
    </div>
    <div style="margin: 10px 0 10px" v-if="bookingIntegralsStatue == 1 || bookingIntegralsStatue == 2">
      <PointGiveaway :point="bookingIntegrals" showPointIcon :isFinishSelfInfo="isFinishSelfInfo" :bookingIntegralsStatue="bookingIntegralsStatue"></PointGiveaway>
    </div>
    <div class="policy-warp">
      <div>
        <RcclCheckBox
          :defaultChecked="false"
          v-on:onChanged="onPrivacyChecked"
        />
      </div>
      <!-- order.bookingIndex&&order.bookingIndex.isRow == false -->
      <div class="policy-info" >
        <span>我确认乘客信息填写正确，已阅读并同意</span>
        <a class="policy policy-contact" v-if="order.bookingIndex.isRow == false" :href="link" target="_blank"
        >《乘客票据合同》</a
        >
        <a class="policy policy-contact" v-else :href="rowLink" target="_blank"
        >《乘客票据合同》</a
        >
<!--        、-->
<!--        <a class="policy policy-privacy" href="https://www.rcclchina.com.cn/content/brand/passenger/repeat" target="_blank"-->
<!--        >《新冠防护隐私政策》</a-->
<!--        >-->
<!--        <span class="policy policy-contact" @click="isShowLegalPopup = true"-->
<!--          >《乘客票据合同》</span-->
<!--        >-->
<!--        <span class="policy policy-privacy" @click="isShowPrivacyPopup = true"-->
<!--          >、《新冠防护隐私政策》</span-->
<!--        >-->
      </div>
      
    </div>
    <div class="policy-warp">
      <div>
        <RcclCheckBox
            :defaultChecked="marketingFlagChecked"
            v-on:onChanged="marketingFlagChange"
        />
      </div>
      <div class="policy-info">
        同意联系人手机号和邮箱接受皇家加勒比品牌资讯及优惠信息
      </div>
    </div>
    <div
      class="submit-btn"
      :class="{ disabled: !isPrivacyChecked }"
      @click="onSubmitBooking"
    >
      提交订单
    </div>
    <div class="return_Top">
      <a @click="goBack">上一步</a>
    </div>

    <BookingLegalPopup
      :isShow="isShowLegalPopup"
      v-on:onModalClose="closePopup"
    />
    <BookingPrivacyPopup
      :isShow="isShowPrivacyPopup"
      v-on:onModalClose="closePopup"
    />
  </div>
</template>

<script>
import _ from "lodash";
import PointGiveaway from "@/components/Booking/PointGiveaway.vue";
const RcclCheckBox = () => import("@/components/Common/RcclCheckBox");
const BookingLegalPopup = () =>
  import("@/components/Booking/BookingLegalPopup");
const BookingPrivacyPopup = () =>
  import("@/components/Booking/BookingPrivacyPopup");

export default {
  name: "GuestInfoRight",
  components: {
    PointGiveaway,
    RcclCheckBox,
    BookingLegalPopup,
    BookingPrivacyPopup,

  },
  props: {
    isDownPayCruise: {
      type: Boolean,
      default: false
    },
    submitBooking: {
      type: Function,
    },
    goBack: {
      type: Function,
    },
    isFinishSelfInfo:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPrivacyChecked: false,
      isShowLegalPopup: false,
      isShowPrivacyPopup: false,
      depositPrice: 1000,
      marketingFlagChecked: false,
      link:`${process.env.VUE_APP_BASE_URL}/content/brand/passenger/repeat`,
      rowLink: `${process.env.VUE_APP_BASE_URL}/content/brand/passenger/repeatRow`,
      imgUrl: process.env.VUE_APP_IMG_URL,
    };
  },
  methods: {
    onPrivacyChecked(value) {
      this.isPrivacyChecked = value;
    },
    // 舱房名称
    getStateroomName(booking) {
      if (!booking.stateroomPartRecord) return "";
      const stateroom = booking.stateroomPartRecord;
      let name = stateroom.cnName + "";
      const shelter = stateroom.stateroomShelter;
      if (shelter && shelter.length > 0 && name.indexOf("遮挡") < 0) {
        name += "（有遮挡）";
      }
      let code = stateroom.stateroomCategoryCode;
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      return `${name}_${code}`;
    },
    getPriceInfo(booking) {
      if (!booking.prices || !booking.prices.priceInfo) return [];
      return booking.prices.priceInfo;
    },
    getOriginalAmount(booking) {
      const originalAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "ORIGINAL_CRUISE_FARE"
      );
      if (originalAmount && originalAmount.length > 0) {
        return originalAmount[0].amount;
      }
      return "";
    },
    getDiscountAmount(booking) {
      const discountAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "DISCOUNTED_CRUISE_FARE"
      );
      if (discountAmount && discountAmount.length > 0) {
        if (discountAmount[0].amount && discountAmount[0].amount.length > 0) {
          return discountAmount[0].amount.replace("-", "");
        }
      }
      return "";
    },
    getDiscountItem(booking) {
      const discountAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "DISCOUNT"
      );
      if (discountAmount && discountAmount.length > 0) {
        return discountAmount[0].priceItems;
      }
      return [];
    },
    getObcItem(booking) {
      const obcItem = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "ONBOARD_CREDITS"
      );
      if (obcItem && obcItem.length > 0) {
        return obcItem[0].priceItems;
      }
      return [];
    },
    getTaxAmount(booking) {
      const taxAmount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "TAXES_AND_FEES"
      );
      if (taxAmount && taxAmount.length > 0) {
        return taxAmount[0].amount;
      }
      return "";
    },
    getTotalPrice(booking) {
      const amount = this.getPriceInfo(booking).filter(
        (r) => r.priceTypeCode == "GROSS_TOTALS"
      );

      if (amount && amount.length > 0) {
        return amount[0].amount;
      }
      return "";
    },
    getBirthdayPrice(booking){
      const amount = this.getPriceInfo(booking).filter(
          (r) => r.priceTypeCode == "SPECIAL_BIRTHDAY_PRICE"
      );
      if (amount && amount.length > 0) {
        return amount[0].amount;
      }
      return "";
    },
    closePopup() {
      this.isShowLegalPopup = false;
      this.isShowPrivacyPopup = false;
    },
    onSubmitBooking() {
      if (!this.isPrivacyChecked) {
        this.$alert.show("请阅读并同意皇家游轮乘客票据合同及隐私政策");
        return;
      }
      this.submitBooking({marketingFlagChecked: this.marketingFlagChecked});
    },
    getGuestName(index, booking) {
      if (
        !booking ||
        !booking.guests ||
        !booking.guests.guestPersons ||
        booking.guests.guestPersons.length < index
      ) {
        return `乘客${index + 1}`;
      }
      const guest = booking.guests.guestPersons[index];
      if (!guest) return `乘客${index + 1}`;

      if (
        guest.lastName &&
        guest.lastName.length > 0 &&
        guest.firstName &&
        guest.firstName.length > 0
      ) {
        return guest.lastName + guest.firstName;
      } else if (
        guest.pyLastName &&
        guest.pyLastName.length > 0 &&
        guest.pyFirstName &&
        guest.pyFirstName.length > 0
      ) {
        return `${guest.pyLastName} ${guest.pyFirstName}`;
      } else {
        return `乘客${index + 1}`;
      }
    },
    marketingFlagChange() {
      this.marketingFlagChecked = !this.marketingFlagChecked;
    }
  },
  computed: {
    order() {
      return this.$store.state.booking.order;
    },
    bookings() {
      if (!this.order.bookings || this.order.bookings.length == 0) {
        return [];
      }
      return this.order.bookings;
    },
    normalBookings() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return [];
      }
      return this.order.bookings.filter(
        (r) => !r.connectId || r.connectId == ""
      );
    },
    connectBookings() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return [];
      }
      return this.order.bookings.filter(
        (r) => r.connectId && r.connectId.length > 0
      );
    },
    totalPrice() {
      return _.sumBy(this.bookings, "netAmount");
    },
    totalDeposit() {
      return this.depositPrice * (_.sumBy(this.bookings, 'guestNumber'));
    },
    //包含套房
    isDeluxeStateroom() {
      let deluxeNum = 0;
      if(this.bookings) {
        this.bookings.forEach((row)=> {
          let stateroomType = row.stateroomPartRecord.stateroomClassPartRecord.stateroomType;
          if(stateroomType === "DELUXE") {
            deluxeNum+=1;
          }
        })
      }
      return deluxeNum > 0;
    },
    // 积分状态
    bookingIntegralsStatue() { 
      if (!this.bookings || this.bookings.length == 0) {
        return 0;
      }
      let newArr = [];
      this.bookings.forEach((booking) => {
        if (booking.bookingIntegrals && booking.bookingIntegrals.length > 0) {
          booking.bookingIntegrals.forEach(item => {
            newArr.push(item)
          })
        }
      });
      // console.log(newArr,'newArrnewArrnewArr');
      if (newArr && newArr.length > 0) {
        const statusList = newArr.map(item => item.status);
        if (statusList.includes(2)) {
          return 2;
        }
        const isAllOne = statusList.every(status => status === 1);
        if (isAllOne) {
          return 1;
        }
      }
      return 0;
    },
    // 计算订单预计获得积分
    bookingIntegrals(){
      if (!this.bookings || this.bookings.length == 0) {
        return [];
      }
      let integrals = 0
      this.bookings.forEach(item=>{
        if(item.bookingIntegrals && item.bookingIntegrals.length>0){
          item.bookingIntegrals.forEach((r) => {
            integrals += r.integral
          })
        }
      })
      return integrals
    }
  },
};
</script>

<style lang="less" scoped>
.order-detail-warp {
  width: 306px;
  height: 100%;
  margin-left: 10px;
  background: #f5f5f5;
  position: relative;
  transition: top 0.5s;
  #clean_html {
    position: relative;
    .order-detail {
      background: #fff;
      border-top: 3px solid #54a3de;
      padding: 10px 15px 10px;
      position: relative;
      .order-title {
        font-size: 22px;
        line-height: 48px;
        letter-spacing: 1px;
        color: #54a3de;
        text-align: center;
      }
      .line-name,
      .duration,
      .ship-name {
        font-size: 20px;
        line-height: 40px;
        letter-spacing: 1px;
        color: #282b2c;
      }
      .line-name {
        line-height: 20px;
      }
      .duration {
        margin-right: 20px;
      }
      .tips-info {
        color: #282b2c;
        margin-bottom: 5px;
      }
      .detail-room-info-warp {
        width: 100%;
        margin-top: 10px;
        .detail-room-title {
          width: 276px;
          height: 36px;
          margin: 0 auto;
          background-color: #e7f5ff;
          border-radius: 18px;
          font-size: 16px;
          letter-spacing: 1px;
          color: #282b2c;
          text-align: center;
          line-height: 36px;
        }
        .detail-room-name {
          padding-bottom: 10px;
          border-bottom: 1px solid #d3dadd;
          padding-top: 10px;
          font-size: 16px;
        }
        .passenger-info {
          padding-bottom: 5px;
          border-bottom: 1px solid #d3dadd;
        }
        .d-passenger-name {
          color: #282b2c;
          margin-bottom: 5px;
          margin-top: 5px;
        }
        .cost-warp {
          padding-left: 10px;
        }
        .group-cost {
          margin-bottom: 7px;
          > span:first-child {
            float: left;
            color: #747d80;
          }
          > span:last-child {
            float: right;
          }
        }
        .group-cost::after {
          display: block;
          clear: both;
          content: "";
          visibility: hidden;
          height: 0;
        }
        .discount-info {
          color: #747d80;
          padding-bottom: 10px;
          border-bottom: 1px solid #d3dadd;
          margin-bottom: 8px;
          > div:last-child {
            padding: 10px;
            background-color: #f3f6f8;
          }
          .group-cost {
            > span:last-child {
              color: #54a3de;
            }
          }
        }

        .total-cost {
          > div {
            float: right;
            .total-text {
              color: #282b2c;

            }
            .total-money {
              font-size: 16px;
              line-height: 30px;
              color: #ff3022;
            }
          }
        }
      }
    }
    .real-cost {
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 10px;
      line-height: 30px;
      background-color: #e7f5ff;
      font-weight: 600;
      & > div:nth-child(1) {
        padding-top: 10px;
        padding-bottom: 9px;
      }
      .total-text{
        font-weight: 500;
        font-size: 16px;
        color: #232B2F;
      }
      .total-money {
        float: right;
        font-size: 24px;
        line-height: 30px;
        color: #ff3022;
      }
      .deposit-money {
        float: right;
        font-size: 20px;
        color: #282b2c;
      }
    }
    .deposit-info {
      margin-top: 7px;
      background: #FFF2D2;
      padding: 10px 14px;
      display: flex;
      align-items: center;
      .deposit-text {
        font-weight: 500;
        font-size: 16px;
        color: #CF7F28;
        line-height: 22px;
      }
      .deposit-currency-symbol {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }

  .policy-warp {
    color: #747d80;
    font-size: 14px;
    margin: 13px auto;
    > div {
      display: inline-block;
      vertical-align: top;
    }
    .policy-info {
      width: 276px;
    }
    .policy {
      color: #006ab9;
      cursor: pointer;
    }
  }

  .real-cost-tips {
    font-size: 12px;
    color: #232B2F;
    line-height: 17px;
    font-weight: 400;
    padding-bottom: 5px;
    margin-top: 8px;
  }
  .total-cost:after,
  .policy-warp:after,
  .visa > div::after,
  .visa > span::after {
    display: block;
    clear: both;
    content: "";
    visibility: hidden;
    height: 0;
  }
  .submit-btn {
    height: 50px;
    background-color: #fbc500;
    font-size: 18px;
    line-height: 48px;
    text-align: center;
    letter-spacing: 1px;
    color: #282b2c;
    cursor: pointer;
  }
  .submit-btn.disabled {
    background-image: none;
    border: none;
    cursor: not-allowed;
  }
  .return_Top {
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    letter-spacing: 1px;
    color: #282b2c;
    cursor: pointer;
    
  }
}
</style>
